import axiosInstance from "./axiosInstance";


const UsersService = {

    getUsers: async() => {
        const response = await axiosInstance.get("/api/users");
        return response.data;
    },

    createUser: async (newUser) => {
        const response = await axiosInstance.post("/api/users", newUser);
        return response.data;
    },

    getUserInfo: async (id) => {
        const response = await axiosInstance.get("/api/users/" + id);
        return response.data;
    },

    deleteUser: async (id) => {
        const response = await axiosInstance.delete("/api/users/" + id);
        return response.data;
    },
    updateUser: async(id, requestData) => {
        const response = await axiosInstance.put("/api/users/" + id, requestData);
        return response.data;
    }

}

export default UsersService